import React from 'react';
import {Card, Statistic} from 'antd';
import {useTranslation} from 'react-i18next';
import {PodExemptReviewQueueStatsType} from '../../graphql/podExempt/types';

interface Props {
  stats: PodExemptReviewQueueStatsType | null;
  /** 待审卡标题（初审=待初审 / 终审=待终审） */
  pendingLabel: string;
  /** 超时卡标题（初审=超12h未处理 / 终审=超24h未处理，口径随角色不同） */
  overdueLabel: string;
  /** 通过率卡标题（本周初审/终审通过率） */
  passRateLabel: string;
}

/**
 * 审核队列统计卡（对齐原型 4 卡：待审 / 超时未处理 / 材料不全 / 本周通过率）。
 * 材料不全口径终审侧不适用（后端返回 null），对应卡不渲染。
 */
const PodExemptReviewQueueStats: React.FC<Props> = ({stats, pendingLabel, overdueLabel, passRateLabel}) => {
  const {t} = useTranslation();
  const cards: Array<{key: string; title: string; value: React.ReactNode}> = [
    {key: 'pending', title: pendingLabel, value: stats != null ? Number(stats.pendingCount) : '-'},
  ];
  if (stats?.overdueCount != null) {
    cards.push({
      key: 'overdue',
      title: overdueLabel,
      value: Number(stats.overdueCount),
    });
  }
  if (stats?.materialIncompleteCount != null) {
    cards.push({
      key: 'materialIncomplete',
      title: t('podExempt.review.statMaterialIncomplete'),
      value: Number(stats.materialIncompleteCount),
    });
  }
  cards.push({
    key: 'passRate',
    title: passRateLabel,
    value: stats?.weeklyPassRatePercent != null ? `${stats.weeklyPassRatePercent}%` : '-',
  });

  // flex-wrap 必需：4 张卡是固定 w-48（合计约 804px），不换行会让本行 min-content 撑爆窄屏容器，
  // 把同一行右侧的搜索区挤出可视区（WMS / QC 两页共用本组件）
  return (
    <div className="flex gap-3 flex-wrap">
      {cards.map((card) => (
        <Card size="small" key={card.key} className="w-48">
          <Statistic title={card.title} value={card.value as string | number} valueStyle={{fontSize: 24}} />
        </Card>
      ))}
    </div>
  );
};

export default PodExemptReviewQueueStats;
